module.exports = __webpack_public_path__ + "static/media/bg-left.b71573cf.png";